export const PERMS = {
    READ: 'report_customer_results.read',
    UPDATE: 'report_customer_results.update',
    DELETE: 'report_customer_results.delete',
    CREATE: 'report_customer_results.create',
    EXPORT: 'report_customer_results.export',
}
